import { createFileRoute } from "@tanstack/react-router"
import { ForgotPasswordPage } from "@/pages"

export const Route = createFileRoute("/_unauthenticated/forgot-password")({
  component: ForgotPasswordPage,
})
